import { noop } from '@/shared/utils/noop';

const STORAGE_KEY = 'redirect_after_login';

export function getRedirectAfterLogin(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setRedirectAfterLogin(url: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, url);
  } catch {
    noop();
  }
}

export function clearRedirectAfterLogin(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    noop();
  }
}
